<span class="content">
  {{ tag }}
  @if (count !== undefined) {
    ({{ count }})
  }
</span>
